import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import {
  ICommentPayload,
  ICurrency,
  IReportTransactionPayload,
} from "../types";

@injectable()
export default class TransactionsClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async fetchTransactions(
    currency: ICurrency,
    page: number = 1,
    size: number = 20
  ): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/transactions/customer`, {
      page,
      size,
      status: "all",
      currency: currency.name,
    });
    this.store.commit("TransactionsModule/setTransactions", response.data);
    return response;
  }

  async fetchTransaction(id: number): Promise<IJsonResponse> {
    return await this.http.get(`/v1/app/transactions/${id}`);
  }

  async getAllCurrencies(): Promise<IJsonResponse> {
    const response = await this.http.get("/v1/app/currencies");
    this.store.commit("TransactionsModule/setCurrencies", response.data);
    return response;
  }

  async reportTransaction({
    message,
    transactionId,
  }: IReportTransactionPayload) {
    const response = await this.http.patch(
      `/v1/app/transactions/report/${transactionId}`,
      { message, transactionId }
    );
    return response.data;
  }

  async getTransactionComments(transactionId: string) {
    const response = await this.http.get(`/v1/app/comments`, {
      transactionId,
      page: 1,
    });

    return response.data;
  }

  async commentOnTransaction({ body, id }: ICommentPayload) {
    return await this.http.post(`/v1/app/comments`, {
      body,
      transactionId: id,
    });
  }
}
